// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"be5bd435136f56b66984","966":"46cc2b0e8f41fae43ff0"}[chunkId] + ".js";
};